import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'CORE IT Group',
  description = 'CORE IT Group delivers practical, security-focused IT, cybersecurity, and risk management services that help organizations operate securely, comply with regulations, and scale with confidence.',
  keywords = 'cybersecurity, IT risk management, GRC, TPRM, SOC 2, ISO 27001, NIST',
  canonical = '',
  type = 'website'
}) => {
  const siteUrl = 'https://coreitgroup.com';
  const fullTitle = title === 'CORE IT Group' 
    ? 'CORE IT Group | Cybersecurity & IT Risk Management Services'
    : `${title} | CORE IT Group`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={`${siteUrl}${canonical}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="CORE IT Group" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`${siteUrl}${canonical}`} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
